var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcMinimartCityFix = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  fill: "none"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13 3 a7.5 7.5 0 0 1 7.5 7.5 c0 5.2 -7.5 12.5 -7.5 12.5 s-7.5 -7.3 -7.5 -12.5 A7.5 7.5 0 0 1 13 3 z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 10.5,
  r: 2.6
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5 26.5 l3 3 l7 -7.5"
}), /*#__PURE__*/React.createElement("line", {
  x1: 4,
  y1: 27.5,
  x2: 14,
  y2: 27.5
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcMinimartCityFix);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_minimart_city_fix.f57de21ad939bfcdefdeb881dd035c03.svg";